/**
 * Postman ENVIRONMENT export → the app's environment shape.
 *
 * The export is `{ id?, name, values: [{ key, value, enabled?, type? }],
 * _postman_variable_scope?: "environment" }` — and the scope marker is
 * OPTIONAL: files exported from current Postman builds can omit it entirely,
 * which is exactly the file this parser exists for.
 *
 * `type` ("default" | "secret") is ignored on purpose: imported values land
 * as plain variables (`secret: false`) so the user can see what arrived and
 * decide what to protect — silently marking rows secret would hide the
 * imported values behind masking with no way to audit them.
 */
export function parsePostmanEnv(data, fallbackName = '') {
  const name =
    (typeof data?.name === 'string' && data.name.trim()) ||
    (fallbackName && String(fallbackName).trim()) ||
    'Imported Environment';

  const variables = (Array.isArray(data?.values) ? data.values : [])
    .filter((v) => v && typeof v.key === 'string' && v.key !== '')
    .map((v) => ({
      key: v.key,
      value: String(v.value ?? ''),
      enabled: v.enabled !== false,
      secret: false,
    }));

  return { name, variables };
}
